import moment from 'moment';
import React, { useState } from 'react'
import { FaFilter } from 'react-icons/fa';
import { MdOutlineClose } from "react-icons/md";
import DatePicker from 'react-datepicker';

const ScreeningFilter = ({ filterData, applyFilters, updateValue, resetFilters }) => {

    const [showFilterDropdown, setShowFilterDropdown] = useState(false);

    return (
        <div className="filter-container">
            <button onClick={() => setShowFilterDropdown((prevState) => !prevState)} className="filter-button"><FaFilter /> Filter</button>
            {showFilterDropdown && (
                <div style={{ height: '250px', overflowY: 'scroll' }} className="filter-dropdown filters">
                    <div onClick={() => setShowFilterDropdown((prevState) => !prevState)} className='close-btn'>
                        <MdOutlineClose />
                    </div>
                    <div className="filter-option">
                        <label>From Date:</label>
                        <DatePicker
                            selected={filterData?.from_date ? moment(filterData.from_date, 'YYYY-MM-DD').toDate() : null}
                            onChange={(date) => updateValue('from_date', moment(date).format('YYYY-MM-DD'))}
                            placeholderText="Select From Date"
                            dateFormat="dd/MM/yyyy"
                        />
                    </div>
                    <div className="filter-option">
                        <label>To Date:</label>
                        <DatePicker
                            selected={filterData?.to_date ? moment(filterData?.to_date, 'YYYY-MM-DD').toDate() : null}
                            onChange={(date) => updateValue('to_date', moment(date).format('YYYY-MM-DD'))}
                            placeholderText="Select To Date"
                            dateFormat="dd/MM/yyyy"
                        />
                    </div>

                    <div className="filter-actions">
                        <button
                            onClick={() => {
                                setShowFilterDropdown((prevState) => !prevState);
                                applyFilters?.();
                            }}
                        >
                            Apply Filters
                        </button>
                        <button
                            onClick={() => {
                                setShowFilterDropdown((prevState) => !prevState);
                                resetFilters?.()
                            }}
                        >
                            Reset Filters
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ScreeningFilter